import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCardDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 15,
	viewBox: "0 0 18 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.45833 11.4583L8.95833 13.9583M8.95833 13.9583L11.4583 11.4583M8.95833 13.9583V8.125M17.2917 4.79167H0.625M3.54167 12.2917H3.29167C2.35825 12.2917 1.89154 12.2917 1.53502 12.11C1.22141 11.9502 0.966445 11.6953 0.806656 11.3816C0.625 11.0251 0.625 10.5584 0.625 9.625V3.29167C0.625 2.35825 0.625 1.89154 0.806656 1.53502C0.966445 1.22141 1.22141 0.966445 1.53502 0.806656C1.89154 0.625 2.35825 0.625 3.29167 0.625H14.625C15.5584 0.625 16.0251 0.625 16.3817 0.806657C16.6953 0.966446 16.9502 1.22141 17.11 1.53502C17.2917 1.89154 17.2917 2.35825 17.2917 3.29167V9.625C17.2917 10.5584 17.2917 11.0251 17.11 11.3817C16.9502 11.6953 16.6953 11.9502 16.3817 12.11C16.0251 12.2917 15.5584 12.2917 14.625 12.2917H14.375",
		stroke: "#0064FA",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCreditCardDown;
